// extracted by mini-css-extract-plugin
export default {"benefitsContainer":"enkSlj","icon":"P6_VPX","lg":"hQSC7D","underline":"DvAGZ9"};